import { useMemo } from "react";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const useDayTripPlanIsDayTripRoot = () => {
	const { viewModel } = useProductDayTripPlanFormModelContext();
	const { isDayTrip, hotelID, isRoomPriceFree, isShowRoomForGuest } = viewModel;

	const isEdited = useMemo(() => {
		return isRoomPriceFree.isEdited || isShowRoomForGuest.isEdited;
	}, [isRoomPriceFree.isEdited, isShowRoomForGuest.isEdited]);

	return {
		isDayTrip,
		hotelID,
		isEdited,
	};
};
